import React from 'react'

import BrassPanel from '../../../components/BrassPanel'
import settings from './machineSettingsData'

function MachineMultiBtn({setPlayerInput}) {
    const buttons = settings.buttonLabels
    
    function handleMultiBtnClick(event) {
        const {textContent} = event.target
        setPlayerInput(prevInput => {
            return ({
                ...prevInput,
                multiBtn: textContent.toLowerCase()
            })
        })
    }
    
    return (
        <BrassPanel extraClasses='machine_panel machine_panel-multiButtons'>
            {buttons.map((btn, index) => {
                return (
                    <button
                        key={index}
                        className='machine_multiButton'
                        onClick={handleMultiBtnClick}
                    >{btn}</button>
                )
            })}
        </BrassPanel>
    )
}

export default MachineMultiBtn